<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>شرائح الاصناف </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة شريحة لصنف</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md8>
                      <v-select
                        v-model="select_item"
                        :items="items"
                        item-text="name"
                        item-value="id"
                        label="أخترالصنف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.item')"
                        data-vv-name="item"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.price"
                        label="السعر"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.price')"
                        data-vv-name="price"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem.from"
                        label="من عدد؟"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.from')"
                        data-vv-name="from"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem.to"
                        label="الي عدد؟"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.to')"
                        data-vv-name="to"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل شريحة لصنف</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md8>
                    <v-select
                      v-model="select_item_edit"
                      :items="items"
                      item-text="name"
                      item-value="id"
                      label="أخترالصنف"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.item')"
                      data-vv-name="item"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.price"
                      label="السعر"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.price')"
                      data-vv-name="price"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      type="number"
                      v-model="editedItem.from"
                      label="من عدد"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.from')"
                      data-vv-name="from"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      type="number"
                      v-model="editedItem.to"
                      label="الي عدد؟"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.to')"
                      data-vv-name="to"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="item_price_layeres"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr :style="{ 'background-color': props.item.item.item_color }">
            <td class="text-xs-right">{{ props.item.item.name }}</td>
            <td class="text-xs-right">{{ props.item.price }}</td>
            <td class="text-xs-right">{{ props.item.from }}</td>
            <td class="text-xs-right">{{ props.item.to }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="editItem(props.item)">
                edit
              </v-icon>
              <v-icon small @click="deleteItem(props.item)">
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  item_price_layeres,
  add_item_price_layer,
  update_item_price_layer,
  delete_item_price_layer
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "الصنف",
        align: "right",
        value: "name"
      },
      {
        text: "السعر",
        align: "right",
        value: "name"
      },
      { text: "عدد من", value: "note", align: "right" },
      { text: "عدد الي", value: "note", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    item_price_layeres: [],
    editedItem: {
      id: "",
      price: "",
      from: "",
      to: "",
      item_id: ""
    },
    newItem: {
      id: "",
      price: "",
      from: "",
      to: "",
      item_id: ""
    },
    select_item: {},
    select_item_edit: {},
    items: []
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      item_price_layeres().then(response => {
        this.item_price_layeres = response.data.layers;
        this.items = response.data.items;
        this.loading = false;
        this.pagination.totalItems = response.data.length;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.editedIndex = this.item_price_layeres.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.price = item.price;
      this.editedItem.from = item.from;
      this.editedItem.to = item.to;
      this.select_item_edit = { id: item.item.id, name: item.item.name };
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.item_price_layeres.indexOf(item);

          this.loading = true;
          delete_item_price_layer(item.id).then(response => {
            this.loading = false;
            this.item_price_layeres.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          var frmData = new FormData();
          frmData.append("item_id", this.select_item.id);
          frmData.append("price", this.newItem.price);
          frmData.append("from", this.newItem.from);
          frmData.append("to", this.newItem.to);
          add_item_price_layer(frmData).then(response => {
            if (response.data == "yes") {
              this.$swal(
                "error",
                "يوجد شريحة لنفس الصنف بتحمل هذه القيم من الي ",
                "error"
              );
              return;
            }
            this.initialize();
            //  this.newItem.name=''
            //  this.newItem.note=''
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
      //   if (this.editedIndex > -1) {
      //     Object.assign(this.item_price_layeres[this.editedIndex], this.editedItem)
      //   } else {
      //     this.item_price_layeres.push(this.editedItem)
      //   }

      // this.close()
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;
          var frmData = new FormData();
          frmData.append("item_id", this.select_item_edit.id);
          frmData.append("price", this.editedItem.price);
          frmData.append("from", this.editedItem.from);
          frmData.append("to", this.editedItem.to);
          update_item_price_layer(frmData, item_id).then(response => {
            this.initialize();
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
